<template>
  <h2 class="v-item-title">{{title}}</h2>
</template>

<script>
export default {
  name: 'index',
  props: {
    title: String,
  },
};
</script>

<style lang="less">
  .v-item-title{
    height: 32px;
    font-size: 22px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: 500;
    line-height: 32px;
  }
</style>
